import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { CreditScoreCLAComponent } from './credit-score-CLA/credit-score-cla.component';
import { OrganisationDetailComponent } from './organisation-detail/organisation-detail.component';
import { CreditsRoutingModule } from './credit-score-routing.module';




@NgModule({
  declarations: [
    CreditScoreCLAComponent,
    OrganisationDetailComponent,

  ],
  imports: [
    CommonModule,
    SharedModule,
    CreditsRoutingModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
  ],
})
export class CreditsCLAModule {}
